import { Injectable     } from '@angular/core';
import { Session        } from 'src/app/interface/session/session';
import { SessionCode    } from 'src/app/enums/session/session-code.enum';
import { SessionKey     } from 'src/app/enums/session/session-key.enum';
import { GuidedCreation } from 'src/app/beans/guided-creation/guided.creation.bean';

@Injectable({
  providedIn: 'root'
})
export class GuidedCreationSession implements Session
{
    constructor() { }

    get(): GuidedCreation | SessionCode
    {
        try
        {
            const object = localStorage.getItem(SessionKey.GUIDED_CREATION) 

            if (!object) return SessionCode.MISSING_VALUE
            return JSON.parse(object)           
        }
        catch(error)
        {
            return SessionCode.GENERIC
        }
    }

    set(object: GuidedCreation): SessionCode
    {
        if(!object) return  SessionCode.INVALID_INPUT

        try
        {
            localStorage.setItem(SessionKey.GUIDED_CREATION, JSON.stringify(object)) 
            return SessionCode.OK
        }
        catch(error)
        {
            return SessionCode.GENERIC
        }
    }

    clear(): SessionCode
    {
        try
        {
            localStorage.removeItem(SessionKey.GUIDED_CREATION) 
            return SessionCode.OK
        }
        catch(error)
        {
            return SessionCode.GENERIC
        }
    }
}

